import React, { useEffect, useRef } from 'react'
import styles from './ActionCard.module.scss'
import { Action } from './HomeActions.tsx'
import { ChevronRight } from 'lucide-react'
import { registerTutorialRef } from '../../../utils/tutorialRefsRegistry.ts'

interface ActionCardProps {
  action: Action
}

const ActionCard: React.FC<ActionCardProps> = ({ action }) => {
  const cardRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    const refId = `action-${action.id}`
    if (cardRef.current) {
      registerTutorialRef(refId, cardRef.current)
    }
    return () => {
      registerTutorialRef(refId, null)
    }
  }, [action.id])

  return (
    <button 
      ref={cardRef}
      className={styles.card}
      onClick={action.onClick}
      style={{ '--action-color': action.color } as React.CSSProperties}
      data-tutorial={`action-${action.id}`}
    >
      <div className={styles.iconWrapper}>
        {action.icon}
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>{action.title}</h3>
        <p className={styles.subtitle}>{action.subtitle}</p>
      </div>
      <div className={styles.arrow}>
        <ChevronRight size={20} />
      </div>
    </button>
  )
}

export default ActionCard
